import CustomIcon from "../../../components/CustomIcon";
import DropdownMenu, {DropdownItem, DropdownItemGroup} from "@atlaskit/dropdown-menu";
import React from "react";
import {savedPresets} from "../constants";

const SavedPresetsList = ({setPreset, disabled, presets, preset}) => {


  return (

    <div className="flex border-2 border-gray-300 rounded-md overflow-hidden">
      {disabled ?
        <div className="cursor-pointer flex items-center cursor-not-allowed divide-x text-tPrimary-200 pr-1">
          <div className="flex items-center space-x-1 px-2.5"><CustomIcon icon="crop_square" size="lg"/> <span
            className="text-xs">Shapes</span></div>
          <CustomIcon icon="keyboard_arrow_down" size="lg" className="pl-1"/>
        </div> :
        <DropdownMenu placement="bottom-end" shouldFlip
                      trigger={({triggerRef, isSelected, testId, ...props}) => (
                        <div title="Saved Presets
                        " className="cursor-pointer flex items-center divide-x hover:text-secondary-500 pr-1"
                             ref={triggerRef} {...props}>
                          <div className="flex items-center space-x-1 px-2.5"><CustomIcon icon="crop_square" size="lg"/>
                            <span className="text-xs">Shapes</span></div>
                          <CustomIcon icon="keyboard_arrow_down" size="lg" className="pl-1"/>
                        </div>


                      )}
        >
          <DropdownItemGroup>
            {
              (presets ?? savedPresets).map((item, i) =>
                <DropdownItem key={`${item.id}${i}`}
                              onClick={() => setPreset(preset ? {
                                ...preset,
                                ar: item.values.ar,
                                ar_web: item.values.ar_web
                              } : item.values)}
                >
                  {item.title}
                </DropdownItem>)
            }

          </DropdownItemGroup>
        </DropdownMenu>
      }
    </div>


  );
};

export default SavedPresetsList;


